import { render, staticRenderFns } from "./OgTableViewToggle.vue?vue&type=template&id=c1d9094a&"
import script from "./OgTableViewToggle.vue?vue&type=script&lang=js&"
export * from "./OgTableViewToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports